import { render } from "./Landing.vue?vue&type=template&id=135f30a9&scoped=true"
const script = {}

import "./Landing.vue?vue&type=style&index=0&id=135f30a9&scoped=true&lang=css"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-135f30a9"]])

export default __exports__